module.exports = __webpack_public_path__ + "img/pink50.df713a99.png";